export const getDefault = () => {
  const schema = {
    name: 'TestimonialsWithLink',
    title: '',
    resource: 'app.organism.testimonials.title',
    backgroundColor: '#F1F1F2',
    textColor: '#000',
    showHeader: true,
    titleProps: {
      hasLine: false,
      hasLink: false
    },
    isEditor: false,
    data: [
      {
        textColor: '#000',
        backgroundColor: '#F1F1F2',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque.',
        person: {
          image: 'https://static.ua.pt/images/ua/placeholder-person.png',
          name: 'Nome A',
          about: 'Descrição',
          alt: ''
        },
        cardUrl: '',
        isEditor: true,
      },
      {
        textColor: '#000',
        backgroundColor: '#F1F1F2',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque.',
        person: {
          image: 'https://static.ua.pt/images/ua/placeholder-person.png',
          name: 'Nome B',
          about: 'Descrição',
          alt: ''
        },
        cardUrl: 'https://www.ua.pt',
        isEditor: true,
      },
      {
        textColor: '#000',
        backgroundColor: '#F1F1F2',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque.',
        person: {
          image: 'https://static.ua.pt/images/ua/placeholder-person.png',
          name: 'Nome C',
          about: 'Descrição',
          alt: ''
        },
        cardUrl: 'https://www.ua.pt',
        isEditor: true,
      },
    ]
  }
  return schema
}
